import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import {NavLink, Link} from 'react-router-dom';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';



class ResultSlip extends Component {
    constructor(props)
    {
        super(props);

        this.fetchTranscript = this.fetchTranscript.bind(this);
        this.generatePDF = this.generatePDF.bind(this);
        this.updateYear = this.updateYear.bind(this);
        this.updateSemester = this.updateSemester.bind(this);


        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
            academicYear:"",
            term:"",
            transcript:[],
            grading:[],
            symbols:[],
            selectedYear: 0,
            selectedSemester: 0,
            averageGrade: null,
            api_loading:false,
            api_loading_message:"",
            loading:false,
            loaded_successfully:false,
            api_error_message:"",
            mode:0,
            server_changes_made:false

        }
    }


    updateYear(event)
      {
          this.setState({selectedYear:event.target.value, server_changes_made:false});
      }

    updateSemester(event)
        {
            this.setState({selectedSemester:event.target.value, server_changes_made:false});
        }

  generatePDF()
  {
    const input = document.getElementById('academic-report');

    html2canvas(input)
    .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'PNG', 5, 20, 200, 297);
        let filename = "AcademicReport_"+this.state.selectedSemester + "_" + this.state.selectedYear;
        filename = filename + "_"+this.props.student_details.core_details.AdmnNo;
        filename = filename+".pdf";
        filename= filename.replace(/\s/g, "");
        pdf.save(filename);
      });

  }


  fetchTranscript()
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/student/resultslip";

            superagent
            .post(url)
            .send({admission_number:_this.props.student_details.core_details.AdmnNo,
                    year:"YEAR " + _this.state.selectedYear,
                    semester:"SEMESTER " + _this.state.selectedSemester,
                    grade_type:_this.props.student_details.programme_details.GradeType})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("Response", res.body);


                if(!error)
                {
                    console.log("Process", "successful loading");

                    _this.setState({grading:res.body.grading, academicYear:res.body.academic_year, term:res.body.term, symbols:res.body.symbols,  transcript:res.body.transcript, averageGrade: res.body.averageGrade, loading:false, loaded_successfully:true, api_error_message:"",server_changes_made:true});

                }
                else
                {
                    _this.setState({loading:false, transcript:[], academicYear:"", term:"", symbols:[], averageGrade: null, grading:[], loaded_successfully:false, api_error_message:res.body.message, server_changes_made:true});
                }

            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, transcript:[], academicYear:"", term:"", symbols:[], averageGrade: null, grading:[],  loaded_successfully:false, api_error_message:err,server_changes_made:true});
            });

  }





  renderErrorMessage()
  {
    const _this = this;

      if(this.state.authentication_error && !this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.api_error_message}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }

  renderTranscriptPeriod()
  {
    const _this = this;
      if(_this.state.selectedYear != 0 && _this.state.selectedSemester != 0 && _this.state.server_changes_made)
      {
          return(
            <span className= "transcript-period">
                 {"FOR ( Year " + _this.state.selectedYear + " Sem : " +  _this.state.selectedSemester +")"}
            </span>

          );
      }
      else{
          return null;
      }
  }

  renderDownloadButton()
  {
    const _this = this;
      if(_this.state.transcript.length > 0 &&  _this.state.server_changes_made)
      {
          return(
                <button className="btn btn-primary btn-round" onClick={_this.generatePDF.bind(_this)} onTap={_this.generatePDF.bind(_this)} >Download<div className="ripple-container"></div></button>

          );
      }
      else{
          return null;
      }
  }

  renderButtons()
  {
    const _this = this;
      if(_this.state.transcript.length > 0 &&  _this.state.server_changes_made)
      {
          return(
              <div>
                <img width="30" height="30" onClick={_this.generatePDF.bind(_this)} />
                <img width="30" height="30" onClick={_this.generatePDF.bind(_this)} />
              </div>

          );
      }
      else{
          return null;
      }
  }

  renderReport()
  {
      const _this = this;

      if(this.state.selectedYear == 0 || this.state.selectedSemester == 0 ||  ! this.state.server_changes_made)
        {
            return(<p className="full-width text-center" style = {{paddingTop:'15px', paddingBottom:'15px'}}> Select Year and Semester then click the Submit button to view Result Slip </p>);
        }
    else if((this.state.selectedYear != 0 && this.state.selectedSemester != 0) && this.state.transcript.length > 0)
    {
        return(
            <div id="academic-report" className ="row block-centered col-lg-12 col-md-12 full-width">
                    <div className = "report-header" className ="row block-centered col-lg-12 col-md-12 full-width">
                        <span className="col-lg-12 block-centered"><center><img src ="/img/logotuc.png" className="header-logo center"/> </center></span>
                        <span className = "col-lg-12 center-align times-n header-name">TURKANA UNIVERSITY COLLEGE</span>
                        <span className = "col-lg-12 center-align comic header-address">(CONSTITUENT COLLEGE OF MASINDE MULIRO UNIVERSITY OF SCIENCE AND TECHNOLOGY)</span>
                        <span className = "col-lg-12 center-align comic header-address">P.O BOX 69-30500 LODWAR- KENYA</span>
                        <span className = "col-lg-12 text-center  header-title">{"ACADEMIC REPORT FOR " + _this.state.term}</span>
                    </div>

                    <div className="col-lg-11 col-md-11 block-centered row full-width">
                       
                            <span className = "col-lg-12 "> <span className="academic-titles">STUDENT NAME: &#09; &#09; &#09; &#09;</span><span className="comic academic-info">{_this.props.student_details.core_details.names}</span></span>
                            <span className = "col-lg-12 "> <span className="academic-titles">REGISTRATION NUMBER: &#09; &#09; </span><span className="comic academic-info">{_this.props.student_details.core_details.AdmnNo}</span></span>
                            <span className = "col-lg-12 "> <span className="academic-titles">PROGRAMME: &#09; &#09; </span><span className="comic academic-info">{_this.props.student_details.class_details.programme}</span></span>
                            <span className = "col-lg-12 "> <span className="academic-titles">DEPARTMENT: &#09; &#09; </span><span className="comic academic-info">{_this.props.student_details.programme_details.department}</span></span>
                            
                            <span className = "col-lg-12 col-md-12">
                                <span className="col-lg-4 col-md-4" style={{paddingLeft:"0"}}>
                                   <span className="academic-titles">ACADEMIC YEAR: &#09; &#09; </span><span className="comic academic-info">{_this.state.academicYear}</span>
                                </span>

                                <span className="col-lg-4 col-md-4">
                                     <span className="academic-titles">YEAR OF STUDY: &#09; &#09; </span><span className="comic academic-info">{_this.state.selectedYear}</span>
                                </span>

                                <span className="col-lg-4 col-md-4">
                                   <span className="academic-titles">SEMESTER: &#09; &#09; </span><span className="comic academic-info">{_this.state.selectedSemester}</span>
                                </span>
                            </span>
                    </div>

                    <div className="col-lg-11 col-md-11 block-centered row full-width">
                        {_this.renderTranscript()}
                    </div>

                    <div className = "row block-centered full-width col-lg-11 col-md-11" style={{marginTop:"15px", marginBottom:"15px"}}>
                        {_this.renderGrading()}
                        {_this.renderSymbols()}
                    </div>
            </div>
  
        );
    }
    else {
        return (<p className="text-center full-width" style = {{color:"red"}}> { this.state.api_error_message }</p> );
      }


      
  }

  renderTranscript()
  {
    const _this = this;

    if ((this.state.selectedYear != 0 && this.state.selectedSemester != 0) && this.state.transcript.length > 0)
    {
      let transcript_list = _this.state.transcript.map(unit =>
          {
            console.log(unit);
            return (
                <tr>
                    <td>
                          {unit.code}
                    </td>
                      <td>
                          {unit.title}
                      </td>
                      <td className="center-align">
                          {unit.cat}
                      </td>
                      <td className="center-align">
                          {unit.exam}
                      </td>
                      <td className="center-align">
                          {unit.total}
                      </td>
                      <td className="center-align">
                          {unit.grade}
                      </td>
                  </tr>
                      );
          });

          return (
              <div className="report-table-div block-centered row col-lg-12 col-md-12" style ={{marginTop:"20px", marginBottom:"15px"}}>
                    <table clasName =" col-lg-12 col-md-12" width ="100%">

                        <thead>
                            <tr>

                                <th style ={{fontWeight:"bold"}}>CODE</th>
                                <th style ={{fontWeight:"bold"}}>NAME</th>
                                <th style ={{fontWeight:"bold"}}>CAT</th>
                                <th style ={{fontWeight:"bold"}}>EXAM</th>
                                <th style ={{fontWeight:"bold"}}>TOTAL</th>
                                <th style ={{fontWeight:"bold"}}>GRADE</th>
                            </tr>
                            </thead>

                        <tbody>

                            {transcript_list}

                            <tr>
                                <th colSpan ="2" className="center-align">Average Grade</th>
                                <th colSpan ="4" className="center-align">{this.state.averageGrade}</th>
                            </tr>

                        </tbody>
                    </table>
            </div>
          );
    }
    


  }

  renderGrading()
  {
    const _this = this;

    if((this.state.transcript.length > 0 && this.state.grading.length > 0) && (this.state.selectedYear != 0 && this.state.selectedSemester != 0 && this.state.server_changes_made) )
    {
      let grading_list = _this.state.grading.map(grade =>
          {
          console.log(grade);
          return (
              <tr>
                  <td>
                      {grade.Range}
                  </td>
                  <td>
                      {grade.Names}
                  </td>
              </tr>
                  );
          });

          return (
            <div className="report-table-div col-lg-5 col-md-6 col-sm-8 col-xs-10 left grading">
                    <h4 className = "inner-title center-align ">Grading</h4>

                    <table width="100%">

                            <thead>
                                <tr>

                                    <th style ={{fontWeight:"bold"}} >Range</th>
                                    <th style ={{fontWeight:"bold"}} >Grade</th>
                                </tr>
                            </thead>
                            <tbody>
                            {grading_list}
                            </tbody>
                    </table>

            </div>
          );
    }


  }

  renderSymbols()
  {
    const _this = this;

    if((this.state.transcript.length > 0 && this.state.symbols.length > 0) && (this.state.selectedYear != 0 && this.state.selectedSemester != 0 && this.state.server_changes_made) )
    {
      let symbol_list = _this.state.symbols.map(symbol =>
          {
          return (
              <tr>
                  <td>
                      {symbol.Symbol}
                  </td>
                  <td>
                      {symbol.Names}
                  </td>
              </tr>
                  );
          });

          return (
            <div className="report-table-div col-lg-5 col-md-6 col-sm-8 col-xs-10 grading" style={{float:"right"}}>
                    <h4 className = "inner-title center-align">Symbols</h4>

                    <table width="100%">

                            <thead>
                                <tr>

                                    <th style ={{fontWeight:"bold"}} >Symbol</th>
                                    <th style ={{fontWeight:"bold"}} >Meaning</th>
                                </tr>
                            </thead>
                            <tbody>
                              {symbol_list}
                            </tbody>
                    </table>

            </div>
          );
    }


  }

  render() {

    const _this=this;
    let transcript_list;
    let grading_list;
    let main_content;


    if(this.state.loading)
    {
        return(
            <div >
                    Loading, Please wait......
                    <ReactLoading className="loading-progress" type="bars" color="#000" height="100px" width="120px"  />
                </div>
        );
    }

    return (
            <div className=" full-width">
                    <div className="col-lg-12 col-md-12">
                        <div className="card full-width">
                            <div className="card-body">
                                <div className="tab-content block-centered">
                                    <div className="tab-pane active" id="profile">
                                        <h4 className ="text-center" style ={{fontWeight:"style"}}>ACADEMIC REPORT  {_this.renderTranscriptPeriod()} {_this.renderDownloadButton()} </h4>

                                        <div className="row full-width block-centered col-lg-8">
                                            <div className="col-lg-4">
                                                YEAR :
                                                <select type="select" value={_this.state.selectedYear} className="select-box" onChange = {this.updateYear.bind(_this)}>
                                                  <option value="0">Select Year</option>
                                                  <option value="1">1</option>
                                                  <option value="2">2</option>
                                                  <option value="3">3</option>
                                                  <option value="4">4</option>
                                                  <option value="5">5</option>
                                                  <option value="6">6</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-4">
                                                Semester:
                                                <select type="select" value={_this.state.selectedSemester} className="select-box" onChange = {this.updateSemester.bind(_this)}>
                                                  <option value="0">Select Semester</option>
                                                  <option value="1">1</option>
                                                  <option value="2">2</option>
                                                </select>
                                            </div>
                                            <div className="col-lg-4 block-centered">
                                                <button className="btn btn-primary btn-round" type="submit" style ={{marginTop:'20px'}} onClick={_this.fetchTranscript.bind(_this)} onTap={_this.fetchTranscript.bind(_this)}  disabled={_this.state.selectedYear == 0 || _this.state.selectedSemester == 0} >Submit<div className="ripple-container"></div></button>
                                            </div>
                                        </div>
                                        {_this.renderReport()}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>





    );
  }
}

export default ResultSlip;
